import { useEffect } from "react";
import { useLocation } from "react-router";
import { styled } from "styled-components";

import { navbarComplementHeight } from "common/constants/navbarHeight";
import { useQueryParams } from "common/utilities";
import { hardNavigate } from "common/utilities/hardNavigate";
import { Footer } from "domains/about/components/Footer";

export const AppRedirectRoute = () => {
  const { search } = useLocation();
  const { redirect_uri } = useQueryParams();

  useEffect(() => {
    if (redirect_uri) hardNavigate(`${redirect_uri}${search}`);
  }, [redirect_uri, search]);

  return <MobileAppPage />;
};

const MobileAppPage = styled(Footer)`
  box-sizing: border-box;
  height: ${navbarComplementHeight};
  justify-content: flex-start;
`;
